import { Component } from 'react';
import Fraction from 'fraction.js';
import PropTypes from 'prop-types';
import { withTranslator } from '@front-activerse/common-components';

class MeasurementUnits extends Component {
  render() {
    return (
      <span className={this.props.className ? this.props.className : 'float-end'}>
        {this.props.measurements.map((measure, k) => {
          let res;
          if (
            measure.unit === 'g' ||
            measure.unit === 'grams' ||
            measure.unit === 'ml' ||
            measure.unit === 'milliliters' ||
            measure.unit === 'oz' ||
            measure.unit === 'fl oz' ||
            measure.unit === 'fl_oz'
          ) {
            res = Math.round(measure.amount * this.props.multiplier * 100) / 100;

            const n = 1.1;
            const decimalSeparator = n.toLocaleString().substring(1, 2);

            res = res.toString().replace('.', decimalSeparator);
          } else {
            let number = measure.amount * this.props.multiplier;
            let intNumber = Math.floor(number);
            let decimalNumber = number % 1;
            decimalNumber = Math.round(decimalNumber * 100) / 100;

            // because 0.33 * 4 = 1.32 and 1.32 is not a natural fraction but 1.33 is,
            // so we need to add 0.01 to the decimal number
            let originalDecimalNumber = measure.amount % 1;
            originalDecimalNumber = Math.round(originalDecimalNumber * 100) / 100;

            const availableDecimals = [0.33, 0.66, 0.99, 0.16, 0.83];

            if (
              // availableDecimals.includes(originalDecimalNumber)
              availableDecimals.includes(originalDecimalNumber) &&
              !availableDecimals.includes(decimalNumber)
            ) {
              const restMultiplier = Math.floor(originalDecimalNumber * this.props.multiplier);
              decimalNumber += restMultiplier * 0.01;
            }

            if (decimalNumber === 0.33) {
              decimalNumber = 1 / 3;
            } else if (decimalNumber === 0.66) {
              decimalNumber = 2 / 3;
            } else if (decimalNumber === 0.99) {
              intNumber += 1;
              decimalNumber = 0;
            } else if (decimalNumber === 0.16) {
              decimalNumber = 1 / 6;
            } else if (decimalNumber === 0.83) {
              decimalNumber = 5 / 6;
            }

            number = intNumber + decimalNumber;

            const x = new Fraction(number);
            const availableDenominators = [2, 3, 4, 5, 6, 8];
            const denominator = Number(x.d);

            // natural fraction
            if (availableDenominators.indexOf(denominator) > -1) {
              res = x.toFraction(true);
              res = res.split('/');

              if (res.length > 1) {
                res = res.map((item, key) => {
                  if (key === 0) {
                    const itemParts = item.split(' ');
                    if (itemParts.length === 1) {
                      return (
                        <span key={key}>
                          <sup>{item}</sup>/
                        </span>
                      );
                    }

                    return (
                      <span key={key}>
                        {itemParts[0]}
                        <sup>{itemParts[1]}</sup>/
                      </span>
                    );
                  }

                  return <sub key={key}>{item}</sub>;
                });
              }
            }
            // decimal fractions
            else {
              res = Math.round(number * 100) / 100;
            }
          }

          if (res !== 0) {
            return (
              <span key={k}>
                {k + 1 === 2 ? ' ≈ ' : ''}
                <span>
                  {/* hack for fractions to return suffix "one" in english and deutsch  */}
                  {res}
                  &nbsp;
                  {this.props.language === 'en-GB' ||
                  this.props.language === 'en-US' ||
                  this.props.language === 'de-DE' ||
                  this.props.language === 'sv-SE'
                    ? measure.amount * this.props.multiplier < 1
                      ? this.props.t(
                          `meal.ingredient.unit.${measure.unit
                            .replaceAll(' ', '_')
                            .replaceAll('.', '')}`,
                          {
                            count: 1,
                          }
                        )
                      : this.props.t(
                          `meal.ingredient.unit.${measure.unit
                            .replaceAll(' ', '_')
                            .replaceAll('.', '')}`,
                          {
                            count: measure.amount * this.props.multiplier,
                          }
                        )
                    : this.props.t(
                        `meal.ingredient.unit.${measure.unit
                          .replaceAll(' ', '_')
                          .replaceAll('.', '')}`,
                        {
                          count: measure.amount * this.props.multiplier,
                        }
                      )}
                </span>
              </span>
            );
          }
          return '';
        })}
      </span>
    );
  }
}

MeasurementUnits.propTypes = {
  measurements: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
    })
  ).isRequired,
  multiplier: PropTypes.number,
};

MeasurementUnits.defaultProps = {
  multiplier: 1,
};

export default withTranslator(MeasurementUnits);
